import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import "../src/globle.css"; // added Css file

const root = ReactDOM.createRoot(document.getElementById("root"));

// ---------------------- disablePrintScreen ---------------
const disablePrintScreen = (e) => {
  if (e.key === "PrintScreen") {
    e.preventDefault();
  }
};

document.addEventListener("keydown", disablePrintScreen);
// ------------------------------

// root.render(                                          Required Later may be !!
//   <React.StrictMode>
//     <ThemeProvider theme={theme}>
//       <App />
//     </ThemeProvider>
//   </React.StrictMode>
// );
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
